module.exports = __webpack_public_path__ + "images/花筑院子全景_01.jpg?v=b99ec863";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_01.jpg
 ** module id = 69
 ** module chunks = 1 2
 **/